import { LaptopOutlined, MobileOutlined } from '@ant-design/icons'
import BAPLIE_FILE_SOURCES from 'constants/baplieFileSources'

const getFileSourceIcon = source => {
  switch (source) {
    case BAPLIE_FILE_SOURCES.WEB:
      return LaptopOutlined
    case BAPLIE_FILE_SOURCES.MOBILE:
      return MobileOutlined
    default:
      return null
  }
}

export default getFileSourceIcon
